import { useState, useEffect, useContext } from "react";
import "./common.scss";
import "./checkbox.css";
import ThemeSelectorContext from "../../services/context/ThemeSelectorContext";
import FormRendererContext from "../../services/context/FormRendererContext";
import { currentFormattedDateAndTime, trackEvent } from "../../utils/mixPanel";

const CheckBoxSelector = ({ data, setAnswer, formValidation }) => {
  const [selectedList, setSelectedList] = useState({});
  const [selectedLabels, setSelectedLabels] = useState([]);
  const [validForm, setFormValidation] = useState(formValidation);

  const { theme } = useContext(ThemeSelectorContext);
  const { isJourneyReadOnly } = useContext(FormRendererContext);

  const handleCheckboxClick = (value, label) => {
    const newSelectedOptions = {
      ...selectedList,
      [value]: !selectedList?.[value],
    };

    setSelectedList(newSelectedOptions);

    if (selectedLabels?.includes(label)) {
      let labelsData = [...selectedLabels];
      labelsData.splice(labelsData.indexOf(label), 1);
      setSelectedLabels(labelsData);
      setAnswer(data, { value: newSelectedOptions, label: labelsData });
      setFormValidation(true);
    } else {
      setSelectedLabels([...selectedLabels, label]);
      setAnswer(data, {
        value: newSelectedOptions,
        label: [...selectedLabels, label],
      });
      setFormValidation(true);
    }
  };

  useEffect(() => {
    setFormValidation(formValidation);
    if (data?.answer) {
      // Handle both old array format and new object format for backward compatibility
      if (Array.isArray(data?.answer?.value)) {
        // Convert old array format to object format
        const convertedOptions = {};
        data?.values?.forEach((item) => {
          convertedOptions[item?.value] = data?.answer?.value?.includes(
            item?.value
          );
        });
        setSelectedList(convertedOptions);
      } else if (
        typeof data?.answer?.value === "object" &&
        data?.answer?.value !== null
      ) {
        // New object format
        setSelectedList(data?.answer?.value);
      }
    } else {
      setSelectedList({})
    }
  }, [formValidation, data]);
  return (
    <div className="w-full">
      <div className="form-title pt-3 mb-2">{data.label}</div>
      {data?.validate?.required ? (
        <span className={!validForm ? "text-red-700" : ""}> * </span>
      ) : (
        <></>
      )}
      {data?.validate?.required && !validForm ? (
        <span className="text-red-700 font-light text-xs">
          {" "}
          Required Field{" "}
        </span>
      ) : (
        <></>
      )}
      {data.values && data.values.length ? (
        <>
          <div>
            {data.values.map((item, index) => {
              return (
                // <div
                //   className="radio-common my-2"
                //   // onClick={() => handleCheckboxClick(item.value)}
                // >
                //   <label>
                //     <input
                //       type="checkbox"
                //       key={index}
                //       value={item.value}
                //       checked={selectedList.includes(item.value)}
                //       className="mr-2"
                //       onChange={() => handleCheckboxClick(item.value)}
                //     />
                //     <span className="form-title">{item.label}</span>
                //   </label>
                // </div>
                <>
                  {theme && theme !== "theme2" ? (
                    <div className="checkbox-wrapper-4 radio-common">
                      <input
                        className="inp-cbx"
                        disabled={data?.disabled || isJourneyReadOnly || false}
                        onChange={() =>
                          handleCheckboxClick(item.value, item.label)
                        }
                        id={data.key + "" + item.value}
                        key={index}
                        value={item.value}
                        checked={selectedList?.[item?.value] || false}
                        type="checkbox"
                      />
                      <label
                        className="cbx"
                        htmlFor={data.key + "" + item.value}
                      >
                        <span className="mr-1 span-first">
                          <svg width="12px" height="10px">
                            <use
                              xlinkHref={`#check${data.key + "" + item.value}`}
                            ></use>
                          </svg>
                        </span>
                        <span className="form-title cbx-label">
                          {item.label}
                        </span>
                      </label>
                      <svg className="inline-svg">
                        <symbol
                          id={`check${data.key + "" + item.value}`}
                          viewBox="0 0 12 10"
                        >
                          <polyline points="1.5 6 4.5 9 10.5 1"></polyline>
                        </symbol>
                      </svg>
                    </div>
                  ) : (
                    <div
                      onClick={() =>
                        !isJourneyReadOnly && !data?.disabled && handleCheckboxClick(item.value, item.label)
                      }
                      className={
                        selectedList?.[item?.value]
                          ? "primary_checked"
                          : "outlined_checked"
                      }
                      style={
                        isJourneyReadOnly || data?.disabled
                          ? { opacity: 0.6, cursor: "not-allowed" }
                          : {}
                      }
                    >
                      <div>{item.label}</div>
                    </div>
                  )}
                </>
              );
            })}
          </div>
        </>
      ) : (
        <></>
      )}
    </div>
  );
};
export default CheckBoxSelector;
